export default "__VITE_ASSET__BvPFpqy6__"